(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactDOM"), require("_"));
	else if(typeof define === 'function' && define.amd)
		define("sign-up", ["React", "ReactDOM", "_"], factory);
	else if(typeof exports === 'object')
		exports["sign-up"] = factory(require("React"), require("ReactDOM"), require("_"));
	else
		root["sign-up"] = factory(root["React"], root["ReactDOM"], root["_"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__1024__, __WEBPACK_EXTERNAL_MODULE__314__, __WEBPACK_EXTERNAL_MODULE__9479__) {
return 